module.exports = __webpack_public_path__ + "img/service_7.svg";